module.exports = __webpack_public_path__ + "static/media/arrow-slider-left-grey.4dfddceb.svg";